export const mockUserPanel = [
  {
    name: 'panel.configuration.data.MainTitle',
    path: 'panel.configuration.url.data',
    automationId: 'configuration_title_data',
    showOn: ['seeker', 'particular', 'inmobiliaria']
  },
  {
    name: 'panel.configuration.changePassword.MainTitle',
    path: 'panel.configuration.url.password',
    automationId: 'configuration_title_password',
    showOn: ['seeker', 'particular', 'inmobiliaria']
  },
  {
    name: 'panel.configuration.emailChange.mainTitle',
    path: 'panel.configuration.url.email',
    automationId: 'configuration_title_email',
    showOn: ['seeker', 'particular']
  },
  {
    name: 'panel.configuration.subscriptions.MainTitle',
    path: 'panel.configuration.url.subscriptions',
    automationId: 'configuration_title_subscriptions',
    showOn: ['seeker', 'particular', 'inmobiliaria']
  },
  {
    name: 'panel.configuration.deleteAccount.MainTitle',
    path: 'panel.configuration.url.deleteAccount',
    automationId: 'configuration_title_delete_account',
    showOn: ['seeker']
  }
];
